import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function BlogPostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog-posts/${id}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="crow-container py-32 text-center" data-testid="post-not-found">
        <p className="font-serif text-3xl text-[#292725]">That page fell out of the journal</p>
        <Link to="/blog" className="mt-6 inline-block rounded-md bg-[#C27803] px-6 py-3 text-sm font-semibold text-[#FDFBF7] hover:bg-[#9A5E02]">
          Back to the Chronicles
        </Link>
      </div>
    );
  }

  if (!post) {
    return <p className="crow-container py-32 text-center font-hand text-2xl text-[#8A7E70]" data-testid="post-loading">turning the pages...</p>;
  }

  return (
    <article className="crow-container max-w-4xl py-12 sm:py-16" data-testid="blog-post-page">
      <Link to="/blog" data-testid="post-back-link" className="flex w-fit items-center gap-2 text-sm font-medium text-[#8A7E70] hover:text-[#C27803]">
        <ArrowLeft className="h-4 w-4" /> Back to the Chronicles
      </Link>
      <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-[#C27803]">{post.topic}</p>
      <h1 className="mt-3 font-serif text-3xl font-semibold leading-tight tracking-tight text-[#292725] sm:text-5xl" data-testid="post-title">
        {post.title}
      </h1>
      <p className="mt-4 font-hand text-xl text-[#8C251C]">
        {new Date(post.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })} · from the shop journal
      </p>
      <img src={post.image_url} alt={post.title} className="mt-8 w-full rounded-md border border-[#D8CDBC] object-cover shadow-sm" data-testid="post-image" />
      <div className="mt-10 space-y-6" data-testid="post-content">
        {post.content.split(/\n+/).map((para, i) => (
          <p key={i} className="text-base leading-relaxed text-[#5C554B] first:font-serif first:text-xl first:text-[#292725]">
            {para}
          </p>
        ))}
      </div>
      <div className="stitched-border mt-12 rounded-md bg-[#F4EFE6] p-8 text-center">
        <p className="font-hand text-2xl text-[#8C251C]">liked what you read?</p>
        <p className="mt-2 text-sm text-[#8A7E70]">Come browse the shelves in person — or send us a note, we love letters.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-4">
          <Link to="/contact" data-testid="post-visit-cta" className="rounded-md bg-[#C27803] px-6 py-3 text-sm font-semibold text-[#FDFBF7] hover:bg-[#9A5E02]">
            Plan a Visit
          </Link>
          <Link to="/contact" data-testid="post-contact-cta" className="rounded-md border border-[#292725] px-6 py-3 text-sm font-semibold text-[#292725] hover:bg-[#292725] hover:text-[#FDFBF7]">
            Write to Us
          </Link>
        </div>
      </div>
    </article>
  );
}
